module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view timelog"
  }, [_c('box', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m20"
  }, [(false) ? _c('inputfield', {
    attrs: {
      "label": "Bruger"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_user_key),
      expression: "filter_user_key"
    }],
    staticClass: "select-styled",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_user_key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.users), function(user, i) {
    return _c('option', {
      domProps: {
        "value": user['.key']
      }
    }, [(user && user.first_name) ? [_vm._v(_vm._s(user.first_name))] : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.userSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.userSelectOptions, 'value', _vm.filter_user_key),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('filter_user_key', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [(false) ? _c('inputfield', {
    attrs: {
      "label": "Kunde"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_client_key),
      expression: "filter_client_key"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_client_key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.clients), function(client, i) {
    return _c('option', {
      domProps: {
        "value": client['.key']
      }
    }, [_vm._v("\n              " + _vm._s(client.name) + "\n            ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.clientSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.clientSelectOptions, 'value', _vm.filter_client_key),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('filter_client_key', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [(false) ? _c('inputfield', {
    attrs: {
      "label": "Opgave"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_project_key),
      expression: "filter_project_key"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_project_key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.projects), function(project, i) {
    return ((!_vm.filter_client_key || _vm.filter_client_key == 'undefined') || _vm.filter_client_key == project.client_key) ? _c('option', {
      domProps: {
        "value": project['.key']
      }
    }, [_vm._v("\n              " + _vm._s(project.name) + " - (" + _vm._s(_vm.getOne('client', project.client_key).name) + ")\n            ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.projectSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.projectSelectOptions, 'value', _vm.filter_project_key),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('filter_project_key', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [_c('inputfield', {
    attrs: {
      "label": 'Fra: ' + _vm.dateFormat(_vm.filter_date_from, 'ddd DD/MM')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_date_from),
      expression: "filter_date_from"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter_date_from)
    },
    on: {
      "focus": function($event) {
        _vm.blockFilterUpdates = true
      },
      "blur": function($event) {
        _vm.blockFilterUpdates = false
      },
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.blockFilterUpdates = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_date_from = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [_c('inputfield', {
    attrs: {
      "label": 'Til: ' + _vm.dateFormat(_vm.filter_date_to, 'ddd DD/MM')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_date_to),
      expression: "filter_date_to"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter_date_to)
    },
    on: {
      "focus": function($event) {
        _vm.blockFilterUpdates = true
      },
      "blur": function($event) {
        _vm.blockFilterUpdates = false
      },
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.blockFilterUpdates = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_date_to = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-day-back')
      }
    }
  }, [_vm._v("—")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('today')
      }
    }
  }, [_vm._v("I dag")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-day-forward')
      }
    }
  }, [_vm._v("+")]), _vm._v("\n       \n    "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-month-back')
      }
    }
  }, [_vm._v("—")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('this-month')
      }
    }
  }, [_vm._v("Indeværende måned")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-month-forward')
      }
    }
  }, [_vm._v("+")]), _vm._v("\n       \n    "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-week-back')
      }
    }
  }, [_vm._v("—")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('last-7-days')
      }
    }
  }, [_vm._v("Sidste 7 dage")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('last-14-days')
      }
    }
  }, [_vm._v("Sidste 14 dage")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('last-30-days')
      }
    }
  }, [_vm._v("Sidste 30 dage")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('last-90-days')
      }
    }
  }, [_vm._v("Sidste 90 dage")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-week-forward')
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_only_billable),
      expression: "filter_only_billable"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kj12b3kj"
    },
    domProps: {
      "checked": Array.isArray(_vm.filter_only_billable) ? _vm._i(_vm.filter_only_billable, null) > -1 : (_vm.filter_only_billable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filter_only_billable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.filter_only_billable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.filter_only_billable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.filter_only_billable = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kj12b3kj"
    }
  }, [_vm._v("Vis kun fakturérbare")])]), _vm._v(" "), (0 && _vm.is_user('wp')) ? _c('span', [_vm._v("cachefiltered_timelogs: " + _vm._s(_vm.cachefiltered_timelogs.length || _vm.all_timelogs_count))]) : _vm._e()], 1), _vm._v(" "), (_vm.filteredTimelogs.length) ? _c('box', {
    attrs: {
      "label": _vm.filteredTimelogs.length + ' timelogs - ' + _vm.getListedTimelogStats.hours_total.toFixed(2) + ' timer'
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m25"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 80,
        height: 80,
        'innerRadius': 0,
        'radius': 40
      },
      "data": _vm.clientsPieData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Kunder")]), _vm._v(" "), _vm._l((_vm.getListedTimelogStats.clients), function(entry, i) {
    return (parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100) > 0) ? _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), (entry.client) ? _c('span', {
      staticClass: "name"
    }, [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + entry.key
      }
    }, [_vm._v(_vm._s(entry.client.name))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100)) + "%\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value)) + " timer\n            ")])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 80,
        height: 80,
        'innerRadius': 0,
        'radius': 40
      },
      "data": _vm.projectsPieData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Opgaver")]), _vm._v(" "), _vm._l((_vm.getListedTimelogStats.projects), function(entry, i) {
    return (parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100) > 0) ? _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + entry.key
      }
    }, [_vm._v(_vm._s(entry.project.name))])], 1), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100)) + "%\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value)) + " timer\n            ")])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 80,
        height: 80,
        'innerRadius': 0,
        'radius': 40
      },
      "data": _vm.usersPieData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Brugere")]), _vm._v(" "), _vm._l((_vm.getListedTimelogStats.users), function(entry, i) {
    return _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [(entry.user) ? [_vm._v(_vm._s(entry.user.first_name || '?'))] : _vm._e()], 2), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100)) + "%\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value)) + " timer\n            ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 80,
        height: 80,
        'innerRadius': 0,
        'radius': 40
      },
      "data": _vm.worktypesPieData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Arbejdstype")]), _vm._v(" "), _vm._l((_vm.getListedTimelogStats.worktypes), function(entry, i) {
    return _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v("\n              " + _vm._s(_vm.translateWorktype(entry.key)) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100)) + "%\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value)) + " timer\n            ")])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.filteredTimelogs.length) ? _c('box', [_c('div', {
    attrs: {
      "_style": "overflow-x:auto;"
    }
  }, [_c('table', {
    staticClass: "table-timespan-dates"
  }, [_c('thead', [_c('tr', _vm._l((_vm.timespanDates), function(entry) {
    return _c('th', {
      attrs: {
        "data-day": entry.dayno
      }
    }, [_c('span', {
      staticClass: "l1"
    }, [_vm._v(_vm._s(entry.date.format('ddd')))]), _vm._v(" "), _c('span', {
      staticClass: "l2"
    }, [_vm._v(_vm._s(entry.date.format('D/M')))])])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.timespanDates), function(entry) {
    return _c('td', {
      attrs: {
        "data-day": entry.dayno
      }
    }, [_c('span', {
      staticClass: "l1"
    }, [_vm._v(_vm._s(entry.hours_logged))]), _vm._v(" "), _c('span', {
      staticClass: "l2"
    }, [_vm._v("timer")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      style: (_vm.barHeight(entry.hours_logged, _vm.maxHoursLoggedInTimeSpanDates))
    })])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.filteredTimelogs.length < 100) ? _c('box', [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), (false) ? _c('th', [_vm._v("Bruger")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Note")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredTimelogs), function(timelog, i) {
    return [(_vm.timelogListDateSpacerBoolean(_vm.filteredTimelogs, i)) ? _c('tr', [_c('td', {
      staticClass: "timelog-date-spacer",
      attrs: {
        "colspan": "9"
      }
    })]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "text": _vm._f("milkinitials")(timelog.user.email)
      }
    })], 1), _vm._v(" "), (false) ? _c('td', [_c('avatar', {
      attrs: {
        "input": timelog.user
      }
    })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('td', [(timelog.user) ? [_vm._v(_vm._s(timelog.user.first_name || '?'))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm._f("weekday1dk")(_vm.nicedate(timelog.date, 'ddd D/M-YY'))) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.hours) + " t\n            ")]), _vm._v(" "), _c('td', [(timelog.project) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + timelog.project_key
      }
    }, [_vm._v(_vm._s(timelog.project.name))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (timelog.client) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + timelog.project.client_key
      }
    }, [_vm._v(_vm._s(timelog.client.name))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.worktype_translated) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.title) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.editTimelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/pencil"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.delete_timelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/trash"
      }
    })], 1)])])]
  })], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.transferTimelogsModal) ? _c('btn', {
    nativeOn: {
      "click": function($event) {
        _vm.transferTimelogsModal = true
      }
    }
  }, [_vm._v("Overfør tidslogs")]) : _vm._e(), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportTimelogs()
      }
    }
  }, [_vm._v("Eksportér tidslogs")]), _vm._v(" "), (_vm.transferTimelogsModal) ? _c('box', {
    attrs: {
      "label": "Overfør tidslogs"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('label', [_vm._v("Fra opgave:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.projectSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.projectSelectOptions, 'value', _vm.transferTimelogsProjectA),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('transferTimelogsProjectA', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('label', [_vm._v("Til opgave:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.projectSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.projectSelectOptions, 'value', _vm.transferTimelogsProjectB),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('transferTimelogsProjectB', $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.is_admin) ? _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.transferTimelogs()
      }
    }
  }, [_vm._v("Overfør tidslogs...")]) : _vm._e(), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        _vm.transferTimelogsModal = false
      }
    }
  }, [_vm._v("Luk")])], 1) : _vm._e(), _vm._v(" "), _vm._l((100), function(i) {
    return _c('br')
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d2c2d64","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Timelogs.vue
// module id = 591
// module chunks = 1